// @flow
import * as React from 'react';
import firebase from 'firebase/app';
import { Route, Redirect } from 'react-router-dom';

type Props = {
  component: React.ComponentType<any>,
};

const UnauthedRoute = ({ component: Component, ...rest }: Props) => (
  <Route
    {...rest}
    render={() => (firebase.auth().currentUser
      ? <Redirect to="/" />
      : <Component />
    )}
  />
);

export default UnauthedRoute;
